import React, { useCallback, useState } from 'react';
import { useCallbackObservable, useObservable } from 'react-use-observable';

import Actions from 'v2/components/Pages/Help/Actions';
import MyTickets from 'v2/components/Pages/Help/MyTickets';
import TopPage from 'v2/components/Shared/TopPage';
import Webchat from 'v2/components/Shared/Webchat';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import helpService from 'v2/services/help';

import HistoryModal from './HistoryModal';

const Help = () => {
  const [isHistoryModalVisible, setIsHistoryModalVisible] = useState(false);
  const [getTicket] = useCallbackObservable((id: number) => helpService.showTicket(id), []);

  const toggleNewHistoryModal = () => {
    setIsHistoryModalVisible(prevState => !prevState);
  };

  const handleHistoryClick = useCallback(
    (ticketId: number) => {
      getTicket(ticketId);
      toggleNewHistoryModal();
    },
    [getTicket]
  );

  const [userDetails] = useObservable(() => eduzzAccountsService.getUser(), []);
  const chatOpenedToUnitOnDash = userDetails?.is_elite || userDetails?.has_chat_black || userDetails?.is_clube_black;

  return (
    <div className='flex flex-col gap-6'>
      {!chatOpenedToUnitOnDash && <Webchat />}
      <TopPage title='Central de Ajuda' extra='Todas suas dúvidas e soluções em um só lugar.' disableAlerts />
      <Actions />
      <MyTickets handleHistoryClick={handleHistoryClick} />
      {isHistoryModalVisible && <HistoryModal isOpen={isHistoryModalVisible} handleClose={toggleNewHistoryModal} />}
    </div>
  );
};

export default Help;
